export const translations = {
    'PTBR': {
        mainPageTitle1: 'O que gostaria de fazer?',
        learnAboutTopic: 'Aprender sobre um tópico',
        startStudySession: 'Iniciar sessão de estudos',
        testAboutTopics: 'Fazer teste sobre tópicos',
        flashcards: 'Flashcards',
        createFlashcards: 'Criar Flashcards',
        myFlashcards: 'Meus Flashcards',
        history: 'Histórico',
        editInfo: 'Editar informações',
        createStudyPlan: 'Criar plano de estudos',
        leave: 'Sair',
        myAccount: 'Minha Conta',
        return: 'Voltar',
        upgradeToPremiumTitle: 'Atualize para premium',
        updagradeToPremiumText: 'Atualize para premium para ter acesso a todos os recursos do sistema de forma ilimitada.',
        currentLanguage: 'Linguagem atual: ',
        myStudyPlans: 'Meus planos de estudos',
        studyPlan: 'Plano de estudos',
        questionLearnAbout: 'Digite sobre o que gostaria de aprender:',
        inputAiPlaceholder: 'Digite aqui o tópico ou cole um texto',
        learnAbout: 'Aprender sobre',
        learnAboutRandom: 'Aprender sobre tópico aleatório',
        topicAnswer: 'Resposta sobre o tópico',
        processingTopic: 'Processando tópico',
        clickToExplain: 'Clique em um termo para explicá-lo melhor:',
        relatedTopics: 'Tópicos relacionados:',
        makeTest: 'Criar teste',
        newTopic: 'Novo tópico',
        processing: 'Processando',
        error: 'Houve um erro, por favor tente novamente',
        anyQuestions: 'Alguma dúvida?',
        typeSomething: 'Digite algo',
        myHistory: 'Meu histórico',
        newSession: 'Nova sessão',
        topics: 'Tópicos',
        tests: 'Testes',
        createdAt: 'Criado em',
        studyTime: 'Tempo de estudo',
        session: 'Sessão',
        noItems: 'Nenhum item encontrado',
        sessionTopics: 'Tópicos da sessão',
        relatedVideos: 'Vídeos relacionados',
        lastActivityDate: 'Última atividade em',
        selectTopics: 'Selecione os tópicos',
        create: 'Criar',
        test: 'Teste',
        next: 'Próximo',
        previous: 'Anterior',
        end: 'Finalizar',
        correctQuestions: 'Questões corretas',
        wrongQuestions: 'Questões erradas',
        unansweredQuestions: 'Questões não respondidas',
        totalQuestions: 'Total de questões',
        yourAnswer: 'Sua resposta',
        correctAnswer: 'Resposta correta',
        isCorrect: 'Você acertou',
        isWrong: 'Você errou',
        quizResults: 'Resultados do teste',
        takeQuiz: 'Fazer teste',
        takeQuizAgain: 'Refazer teste',
        noAnswer: 'Nenhuma resposta',
        myQuizzes: 'Meus testes',
        createQuiz: 'Criar teste',
        quiz: 'Teste',
        selectTopicsError: 'Selecione pelo menos um tópico',
        goBackToSession: 'Voltar para a sessão',
        cardsAmount: 'Quantidade de cartões',
        comingSoon: 'Funcionalidade será disponibilizada em breve'
    },
    'EN': {
        mainPageTitle1: 'What would you like to do?',
        learnAboutTopic: 'Learn about a topic',
        startStudySession: 'Start study session',
        testAboutTopics: 'Take a test about topics',
        flashcards: 'Flashcards',
        createFlashcards: 'Create Flashcards',
        myFlashcards: 'My Flashcards',
        history: 'History',
        editInfo: 'Edit information',
        createStudyPlan: 'Create study plan',
        leave: 'Quit',
        myAccount: 'My Account',
        return: 'Return',
        upgradeToPremiumTitle: 'Upgrade to premium',
        updagradeToPremiumText: 'Upgrade to premium to have access to all system resources unlimitedly.',
        currentLanguage: 'Current language: ',
        myStudyPlans: 'My study plans',
        studyPlan: 'Study plan',
        questionLearnAbout: 'Type about what you would like to learn:',
        inputAiPlaceholder: 'Type here the topic or paste a text',
        learnAbout: 'Learn about',
        learnAboutRandom: 'Learn about random topic',
        topicAnswer: 'Answer about the topic',
        processingTopic: 'Processing topic',
        clickToExplain: 'Click on a term to explain it better:',
        relatedTopics: 'Related topics:',
        makeTest: 'Make test',
        newTopic: 'New topic',
        processing: 'Processing',
        error: 'There was an error, please try again',
        anyQuestions: 'Any questions?',
        typeSomething: 'Type something',
        myHistory: 'My history',
        newSession: 'New session',
        topics: 'Topics',
        tests: 'Tests',
        createdAt: 'Created at',
        studyTime: 'Study time',
        session: 'Session',
        noItems: 'No items found',
        sessionTopics: 'Session topics',
        relatedVideos: 'Related videos',
        lastActivityDate: 'Last activity on',
        selectTopics: 'Select topics',
        create: 'Create',
        test: 'Test',
        next: 'Next',
        previous: 'Previous',
        end: 'Finish',
        correctQuestions: 'Correct questions',
        wrongQuestions: 'Wrong questions',
        unansweredQuestions: 'Unanswered questions',
        totalQuestions: 'Total questions',
        yourAnswer: 'Your answer',
        correctAnswer: 'Correct answer',
        isCorrect: 'You got it right',
        isWrong: 'You got it wrong',
        quizResults: 'Quiz results',
        takeQuiz: 'Take quiz',
        takeQuizAgain: 'Take quiz again',
        noAnswer: 'No answer',
        myQuizzes: 'My quizzes',
        createQuiz: 'Create quiz',
        quiz: 'Quiz',
        selectTopicsError: 'Select at least one topic',
        goBackToSession: 'Go back to session',
        cardsAmount: 'Cards amount',
        comingSoon: 'Feature will be available soon'
    },
    'ES': {
        mainPageTitle1: '¿Qué te gustaría hacer?',
        learnAboutTopic: 'Aprender sobre un tema',
        startStudySession: 'Iniciar sesión de estudio',
        testAboutTopics: 'Hacer prueba sobre temas',
        flashcards: 'Flashcards',
        createFlashcards: 'Crear Flashcards',
        myFlashcards: 'Mis Flashcards',
        history: 'Historial',
        editInfo: 'Editar información',
        createStudyPlan: 'Crear plan de estudios',
        leave: 'Salir',
        myAccount: 'Mi cuenta',
        return: 'Volver',
        upgradeToPremiumTitle: 'Actualiza a premium',
        updagradeToPremiumText: 'Actualice a premium para tener acceso a todos los recursos del sistema de forma ilimitada.',
        currentLanguage: 'Idioma actual: ',
        myStudyPlans: 'Mis planes de estudio',
        studyPlan: 'Plan de estudios',
        questionLearnAbout: 'Escribe sobre lo que te gustaría aprender:',
        inputAiPlaceholder: 'Escribe aquí el tema o pega un texto',
        learnAbout: 'Aprender sobre',
        learnAboutRandom: 'Aprender sobre tema aleatorio',
        topicAnswer: 'Respuesta sobre el tema',
        processingTopic: 'Procesando tema',
        clickToExplain: 'Haz clic en un término para explicarlo mejor:',
        relatedTopics: 'Temas relacionados:',
        makeTest: 'Hacer prueba',
        newTopic: 'Nuevo tema',
        processing: 'Procesando',
        error: 'Hubo un error, por favor intenta de nuevo',
        anyQuestions: '¿Alguna pregunta?',
        typeSomething: 'Escribe algo',
        myHistory: 'Mi historial',
        newSession: 'Nueva sesión',
        topics: 'Temas',
        tests: 'Pruebas',
        createdAt: 'Creado en',
        studyTime: 'Tiempo de estudio',
        session: 'Sesión',
        noItems: 'No se encontraron elementos',
        sessionTopics: 'Temas de la sesión',
        relatedVideos: 'Videos relacionados',
        lastActivityDate: 'Última actividad en',
        selectTopics: 'Seleccionar temas',
        create: 'Crear',
        test: 'Prueba',
        next: 'Siguiente',
        previous: 'Anterior',
        end: 'Finalizar',
        correctQuestions: 'Preguntas correctas',
        wrongQuestions: 'Preguntas incorrectas',
        unansweredQuestions: 'Preguntas sin respuesta',
        totalQuestions: 'Total de preguntas',
        yourAnswer: 'Tu respuesta',
        correctAnswer: 'Respuesta correcta',
        isCorrect: 'Acertaste',
        isWrong: 'Te equivocaste',
        quizResults: 'Resultados de la prueba',
        takeQuiz: 'Hacer prueba',
        takeQuizAgain: 'Hacer prueba de nuevo',
        noAnswer: 'Sin respuesta',
        myQuizzes: 'Mis pruebas',
        createQuiz: 'Crear prueba',
        quiz: 'Prueba',
        selectTopicsError: 'Selecciona al menos un tema',
        goBackToSession: 'Volver a la sesión',
        cardsAmount: 'Cantidad de tarjetas',
        comingSoon: 'Funcionalidad será disponibilizada en breve'
    },
    'FR': {
        mainPageTitle1: 'Que voudriez-vous faire?',
        learnAboutTopic: 'Apprendre sur un sujet',
        startStudySession: 'Démarrer une session d\'étude',
        testAboutTopics: 'Faire un test sur des sujets',
        flashcards: 'Flashcards',
        createFlashcards: 'Créer des Flashcards',
        myFlashcards: 'Mes Flashcards',
        history: 'Historique',
        editInfo: 'Modifier les informations',
        createStudyPlan: 'Créer un plan d\'étude',
        leave: 'Quitter',
        myAccount: 'Mon compte',
        return: 'Retour',
        upgradeToPremiumTitle: 'Passer à premium',
        updagradeToPremiumText: 'Passez à premium pour avoir accès à toutes les ressources du système de manière illimitée.',
        currentLanguage: 'Langue actuelle: ',
        myStudyPlans: 'Mes plans d\'étude',
        studyPlan: 'Plan d\'étude',
        questionLearnAbout: 'Tapez sur ce que vous aimeriez apprendre:',
        inputAiPlaceholder: 'Tapez ici le sujet ou collez un texte',
        learnAbout: 'Apprendre sur',
        learnAboutRandom: 'Apprendre sur sujet aléatoire',
        topicAnswer: 'Réponse sur le sujet',
        processingTopic: 'Traitement du sujet',
        clickToExplain: 'Cliquez sur un terme pour l\'expliquer mieux:',
        relatedTopics: 'Sujets liés:',
        makeTest: 'Faire un test',
        newTopic: 'Nouveau sujet',
        processing: 'Traitement',
        error: 'Il y a eu une erreur, veuillez réessayer',
        anyQuestions: 'Des questions?',
        typeSomething: 'Tapez quelque chose',
        myHistory: 'Mon historique',
        newSession: 'Nouvelle session',
        topics: 'Sujets',
        tests: 'Tests',
        createdAt: 'Créé à',
        studyTime: 'Temps d\'étude',
        session: 'Session',
        noItems: 'Aucun élément trouvé',
        sessionTopics: 'Sujets de la session',
        relatedVideos: 'Vidéos connexes',
        lastActivityDate: 'Dernière activité le',
        selectTopics: 'Sélectionner des sujets',
        create: 'Créer',
        test: 'Test',
        next: 'Suivant',
        previous: 'Précédent',
        end: 'Finir',
        correctQuestions: 'Questions correctes',
        wrongQuestions: 'Questions incorrectes',
        unansweredQuestions: 'Questions sans réponse',
        totalQuestions: 'Total des questions',
        yourAnswer: 'Votre réponse',
        correctAnswer: 'Réponse correcte',
        isCorrect: 'Vous avez eu raison',
        isWrong: 'Vous avez eu tort',
        quizResults: 'Résultats du test',
        takeQuiz: 'Faire le test',
        takeQuizAgain: 'Refaire le test',
        noAnswer: 'Pas de réponse',
        myQuizzes: 'Mes tests',
        createQuiz: 'Créer un test',
        quiz: 'Test',
        selectTopicsError: 'Sélectionnez au moins un sujet',
        goBackToSession: 'Retourner à la session',
        cardsAmount: 'Montant des cartes',
        comingSoon: 'Fonctionnalité sera disponible bientôt'
    },
    'DE': {
        mainPageTitle1: 'Was möchten Sie tun?',
        learnAboutTopic: 'Über ein Thema lernen',
        startStudySession: 'Lernsession starten',
        testAboutTopics: 'Test über Themen machen',
        flashcards: 'Flashcards',
        createFlashcards: 'Flashcards erstellen',
        myFlashcards: 'Meine Flashcards',
        history: 'Geschichte',
        editInfo: 'Informationen bearbeiten',
        createStudyPlan: 'Lernplan erstellen',
        leave: 'Verlassen',
        myAccount: 'Mein Konto',
        return: 'Zurück',
        upgradeToPremiumTitle: 'Upgrade auf Premium',
        updagradeToPremiumText: 'Upgrade auf Premium, um unbegrenzten Zugriff auf alle Systemressourcen zu haben.',
        currentLanguage: 'Aktuelle Sprache: ',
        myStudyPlans: 'Meine Lernpläne',
        studyPlan: 'Lernplan',
        questionLearnAbout: 'Geben Sieein, worüber Sie lernen möchten:',
        inputAiPlaceholder: 'Geben Sie hier das Thema ein oder fügen Sie einen Text ein',
        learnAbout: 'Über lernen',
        learnAboutRandom: 'Über zufälliges Thema lernen',
        topicAnswer: 'Antwort zum Thema',
        processingTopic: 'Thema wird verarbeitet',
        clickToExplain: 'Klicken Sie auf einen Begriff, um ihn besser zu erklären:',
        relatedTopics: 'Verwandte Themen:',
        makeTest: 'Test machen',
        newTopic: 'Neues Thema',
        processing: 'Verarbeitung',
        error: 'Es gab einen Fehler, bitte versuchen Sie es erneut',
        anyQuestions: 'Irgendwelche Fragen?',
        typeSomething: 'Etwas eingeben',
        myHistory: 'Meine Geschichte',
        newSession: 'Neue Sitzung',
        topics: 'Themen',
        tests: 'Tests',
        createdAt: 'Erstellt am',
        studyTime: 'Studienzeit',
        session: 'Sitzung',
        noItems: 'Keine Elemente gefunden',
        sessionTopics: 'Sitzungsthemen',
        relatedVideos: 'Verwandte Videos',
        lastActivityDate: 'Letzte Aktivität am',
        selectTopics: 'Themen auswählen',
        create: 'Erstellen',
        test: 'Test',
        next: 'Nächster',
        previous: 'Vorheriger',
        end: 'Beenden',
        correctQuestions: 'Korrekte Fragen',
        wrongQuestions: 'Falsche Fragen',
        unansweredQuestions: 'Nicht beantwortete Fragen',
        totalQuestions: 'Gesamtfragen',
        yourAnswer: 'Ihre Antwort',
        correctAnswer: 'Richtige Antwort',
        isCorrect: 'Sie haben richtig',
        isWrong: 'Sie haben falsch',
        quizResults: 'Testergebnisse',
        takeQuiz: 'Test machen',
        takeQuizAgain: 'Test erneut machen',
        noAnswer: 'Keine Antwort',
        myQuizzes: 'Meine Tests',
        createQuiz: 'Test erstellen',
        quiz: 'Test',
        selectTopicsError: 'Wählen Sie mindestens ein Thema aus',
        goBackToSession: 'Zurück zur Sitzung',
        cardsAmount: 'Kartenanzahl',
        comingSoon: 'Funktion wird bald verfügbar sein'
    },
    'IT': {
        mainPageTitle1: 'Cosa vorresti fare?',
        learnAboutTopic: 'Imparare su un argomento',
        startStudySession: 'Iniziare una sessione di studio',
        testAboutTopics: 'Fare un test su argomenti',
        flashcards: 'Flashcards',
        createFlashcards: 'Crea Flashcards',
        myFlashcards: 'Le mie Flashcards',
        history: 'Storia',
        editInfo: 'Modifica informazioni',
        createStudyPlan: 'Crea piano di studi',
        leave: 'Lascia',
        myAccount: 'Il mio account',
        return: 'Ritorno',
        upgradeToPremiumTitle: 'Passa a premium',
        updagradeToPremiumText: 'Passa a premium per avere accesso illimitato a tutte le risorse del sistema.',
        currentLanguage: 'Lingua corrente: ',
        myStudyPlans: 'I miei piani di studio',
        studyPlan: 'Piano di studi',
        questionLearnAbout: 'Digita su cosa vorresti imparare:',
        inputAiPlaceholder: 'Digita qui l\'argomento o incolla un testo',
        learnAbout: 'Imparare su',
        learnAboutRandom: 'Imparare su argomento casuale',
        topicAnswer: 'Risposta sull\'argomento',
        processingTopic: 'Elaborazione dell\'argomento',
        clickToExplain: 'Fai clic su un termine per spiegarlo meglio:',
        relatedTopics: 'Argomenti correlati:',
        makeTest: 'Fare test',
        newTopic: 'Nuovo argomento',
        processing: 'Elaborazione',
        error: 'Si è verificato un errore, riprovare',
        anyQuestions: 'Qualche domanda?',
        typeSomething: 'Scrivi qualcosa',
        myHistory: 'La mia storia',
        newSession: 'Nuova sessione',
        topics: 'Argomenti',
        tests: 'Test',
        createdAt: 'Creato il',
        studyTime: 'Tempo di studio',
        session: 'Sessione',
        noItems: 'Nessun elemento trovato',
        sessionTopics: 'Argomenti della sessione',
        relatedVideos: 'Video correlati',
        lastActivityDate: 'Ultima attività il',
        selectTopics: 'Seleziona argomenti',
        create: 'Creare',
        test: 'Test',
        next: 'Prossimo',
        previous: 'Precedente',
        end: 'Fine',
        correctQuestions: 'Domande corrette',
        wrongQuestions: 'Domande sbagliate',
        unansweredQuestions: 'Domande senza risposta',
        totalQuestions: 'Domande totali',
        yourAnswer: 'La tua risposta',
        correctAnswer: 'Risposta corretta',
        isCorrect: 'Hai indovinato',
        isWrong: 'Hai sbagliato',
        quizResults: 'Risultati del quiz',
        takeQuiz: 'Fare quiz',
        takeQuizAgain: 'Fare quiz di nuovo',
        noAnswer: 'Nessuna risposta',
        myQuizzes: 'I miei quiz',
        createQuiz: 'Crea quiz',
        quiz: 'Quiz',
        selectTopicsError: 'Seleziona almeno un argomento',
        goBackToSession: 'Torna alla sessione',
        cardsAmount: 'Quantità di schede',
        comingSoon: 'Funzionalità sarà disponibile a breve'
    }
}

export type LanguageKeys = keyof typeof translations;